export default __webpack_public_path__ + "static/media/android-logo-tablet.48713d6f.svg";